export default __webpack_public_path__ + "static/web_img4-4540ad020eaf046aa6f05cb84a6d1062.webp";